export const SERVER = "https://www.terradata.com.br/";

export const LOGIN = SERVER + 'api/auth/login.php';

export const PROFILE_CREATE = SERVER + 'api/profile/create.php';
export const PROFILE_UPDATE = SERVER + 'api/profile/update.php';